import React, { Component } from "react";
import { connect } from "react-redux";

import {
	createNewClient,
	updateClient,
	fetchClientDetail,
	getEverythingForNewClient,
	getEverythingForEditClient,
	unmountNewEditClient,
} from "../actions/clientActions";
import { clientStatusOptions, clientStatusLookup } from "../SelectableOptions";
import { LabeledTextInput } from "./TextInput";
import { LabeledDropDownSelect } from "./DropDownSelect";
import UsersDropDownSelect from "./UsersDropDownSelect";
import TwoColumnWrapper from "./TwoColumnWrapper";
import { TrashBinMessage } from "./Utils/UnderSubHeaderWarningMessages";
import { IconUsersGroup } from "@tabler/icons-react";
import {
	getClientLifecycleStatusObject,
	NORMAL_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";

const tagLabelMap = (tag) => ({
	value: tag.name,
	label: tag.name,
});
const propTagsMap = (tag) => ({
	label: tag.tagName,
	value: tag.tagName,
});
const userOptionsMap = (user) => {
	return { ...user, value: user.id, label: user.displayName };
};

const initialState = {
	newClientName: "",
	newClientStatus: { value: "active", label: "Active" },
	primaryAttorneys: [],
	clientTags: [],
};

class NewClient extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newClientName: "",
			newClientStatus: { value: "active", label: "Active" },
			primaryAttorneys: [],
			clientTags: [],
			loading: true,
		};
		this.handleChange = this.handleChange.bind(this);
		this.canSubmit = this.canSubmit.bind(this);
		this.submit = this.submit.bind(this);
	}
	static getDerivedStateFromProps(props, state) {
		if (state.loading && !props.loading) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const clientNameFromSearchParams =
				urlSearchParams.get("name") || "";
			const newState = props.editMode
				? {
						loading: false,
						newClientName: props.clientDetails.clientName,
						newClientStatus:
							clientStatusOptions[
								props.editMode
									? clientStatusLookup[
											props.clientDetails.clientStatus
										]
									: 0
							],
						clientTags: props.clientDetails.tags
							? props.clientDetails.tags.map(propTagsMap)
							: [],
						primaryAttorneys: props.clientDetails.primaryAttorneys
							? props.clientDetails.primaryAttorneys.map(
									userOptionsMap
								)
							: [],
					}
				: {
						...initialState,
						newClientName: clientNameFromSearchParams,
						loading: false,
					};

			return newState;
		} else {
			return null;
		}
	}
	componentDidMount() {
		if (this.props.editMode) {
			this.props.getEverythingForEditClient(
				this.props.match.params.id,
				this.props.history
			);
		} else {
			this.props.getEverythingForNewClient();
		}
	}
	componentDidUpdate(prevProps) {
		if (prevProps.editMode !== this.props.editMode) {
			if (this.props.editMode) {
				this.props.getEverythingForEditClient(
					this.props.match.params.id,
					this.props.history
				);
			} else {
				this.props.getEverythingForNewClient();
			}
		}
	}
	componentWillUnmount() {
		this.props.unmountNewEditClient();
	}
	handleChange(key, value) {
		this.setState({ [key]: value });
	}
	submit() {
		if (this.props.editMode) {
			this.props.updateClient(this.props.match.params.id, this.state);
		} else {
			this.props.createNewClient(this.state);
		}
	}
	canSubmit() {
		return (
			this.state.newClientName.trim() !== "" &&
			(!this.props.editMode ||
				this.props.clientDetails.clientLifecycleStatus ===
					NORMAL_LIFECYCLE_STATUS)
		);
	}
	render() {
		const isEditingClientDisabled =
			this.props.editMode &&
			this.props.clientLifecycleStatusObject.disabled;
		if (this.state.loading) {
			return (
				<div>
					<h1>
						Loading<span className="Loading">...</span>
					</h1>
				</div>
			);
		} else {
			return (
				<>
					{this.props.clientLifecycleStatusObject.IN_TRASH
						? TrashBinMessage({
								objectType: "Client",
								itemLocation: "Trash Bin",
							})
						: null}
					<TwoColumnWrapper
						headingText="Client Information"
						iconComponent={
							<IconUsersGroup
								size={16}
								style={{ verticalAlign: "middle" }}
							/>
						}
						submit={this.submit.bind(this)}
						canSubmit={this.canSubmit()}
						submitButtonText={
							this.props.editMode
								? "Update Client"
								: "Create Client"
						}
						leftChildren={
							<div>
								<LabeledTextInput
									label="Client Name*"
									name="newClientName"
									placeholder="New Client Name"
									defaultValue={
										this.props.editMode
											? this.props.clientDetails
													.clientName
											: this.state.newClientName
									}
									onChange={this.handleChange}
									disabled={isEditingClientDisabled}
								/>
								<LabeledDropDownSelect
									label="Client Status"
									options={clientStatusOptions}
									defaultValue={
										clientStatusOptions[
											this.props.editMode
												? clientStatusLookup[
														this.props.clientDetails
															.clientStatus
													]
												: 0
										]
									}
									name="newClientStatus"
									handler={this.handleChange}
									isDisabled={isEditingClientDisabled}
								/>
							</div>
						}
						rightChildren={
							<div>
								<UsersDropDownSelect
									// the label was "Primary Attorney(s)" but changed to "Assigned Staff" per UX feedback
									// the database still stores this information in the PrimaryAttorneysForClient table
									label="Assigned Staff"
									isMulti
									name="primaryAttorneys"
									defaultValue={
										this.props.editMode &&
										this.props.clientDetails
											.primaryAttorneys
											? this.props.clientDetails.primaryAttorneys.map(
													userOptionsMap
												)
											: []
									}
									isAsync
									options={this.props.availablePrimaryAttorneys.map(
										userOptionsMap
									)}
									handler={this.handleChange}
									isDisabled={isEditingClientDisabled}
								/>
								<LabeledDropDownSelect
									label="Client Tag(s)"
									isMulti
									name="clientTags"
									isCreatable={
										this.props.userRights.CRUD_CLIENT_TAGS
									}
									isAsync
									defaultValue={
										this.props.editMode &&
										this.props.clientDetails.tags
											? this.props.clientDetails.tags.map(
													propTagsMap
												)
											: []
									}
									options={this.props.availableClientTags
										.filter(
											(tag) => tag.status === "active"
										)
										.map(tagLabelMap)}
									handler={this.handleChange}
									isDisabled={isEditingClientDisabled}
								/>
							</div>
						}
					/>
				</>
			);
		}
	}
}
const mapStateToProps = (state) => {
	return {
		availableClientTags: state.client.availableClientTags,
		availablePrimaryAttorneys: state.client.availablePrimaryAttorneys,
		clientDetails: state.client.clientDetails,
		clientLifecycleStatusObject: getClientLifecycleStatusObject(
			state.client.clientDetails.clientLifecycleStatus
		),
		loading: state.client.newEditClientLoading,
		userRights: state.user.userRights,
	};
};

export default connect(mapStateToProps, {
	createNewClient,
	updateClient,
	fetchClientDetail,
	getEverythingForNewClient,
	getEverythingForEditClient,
	unmountNewEditClient,
})(NewClient);
